{
    "features-majority-account-get-paid-early": {
        "meta": {
            "title": "Get paid early - MAJORITY",
            "description": "Need your paycheck before Friday? Get paid up to two days early with MAJORITY! Learn more."
        },
        "hero": {
            "title": "Get paid early!",
            "body": "Get paid early with early direct deposit in the MAJORITY app.",
            "cta": "Get paid early"
        },
        "get_paid_early_content_box": {
            "tagline": "Majority Account",
            "title": "Get paid 2 days early",
            "body": "Payday just came earlier. When you use the MAJORITY app to sign up for early direct deposit, you can get paid up to two days early. Never wait until Friday to treat yourself or pay the bills again. No early paycheck requests required.",
            "cta": "Get started"
        },
        "how_to_content_box": {
            "tagline": "Majority Account",
            "title": "How to get paid early",
            "body": "It’s easy to get paid early with the MAJORITY app. Simply download the app and follow these steps.\n+ Go to “Account”\n+ Select “Get paid early”\n+ Click “Go set it up”\n+ Select “Get direct deposit form”\n+ Print out the form\n+ Answer all questions\n+ Sign form\n+ Give the direct deposit form to your employer\n+ Get your paycheck early!",
            "cta": "Get started"
        },
        "more_than_paid_early_content_box": {
            "tagline": "Majority Account",
            "title": "Looking for more than just a get paid early app?",
            "body": "Look no further. MAJORITY is a get paid early app with so much more to offer. With a MAJORITY account, you can sign up for early direct deposit without paying hefty minimum balance and overdraft fees. Plus, you’ll receive a Visa® Debit Card which gives you access to exclusive discounts, you can send money, and make international calls.",
            "cta": "See full membership",
            "canvas": "Save more with MAJORITY"
        }
    }
}